
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stocks/[stockSlug]/technicalchart",
      function () {
        return require("private-next-pages/stocks/[stockSlug]/technicalchart/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stocks/[stockSlug]/technicalchart"])
      });
    }
  